/**
 * @generated SignedSource<<803c5b236e29056f89613ab4175649fa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type PlanSlug = "BANQUET" | "CHEFS_SPECIAL" | "DEGUSTER" | "GOURMET" | "TWOHDSC" | "%future added value";
export type SubscriptionStatus = "ACTIVE" | "CANCELLED" | "PAST_DUE" | "PENDING" | "%future added value";
export type SubscriptionPlansQuery$variables = {};
export type SubscriptionPlansQuery$data = {
  readonly activePaymentProvider: string;
  readonly subscriptionPlans: ReadonlyArray<{
    readonly comingSoon: boolean;
    readonly name: string;
    readonly slug: PlanSlug;
    readonly valueCents: number;
  }>;
  readonly viewer: {
    readonly savedCards: ReadonlyArray<{
      readonly createdAt: any;
      readonly creditCardBrand: string;
      readonly creditCardNumber: string;
      readonly holderName: string;
      readonly id: string;
      readonly isPrimary: boolean;
    }>;
    readonly subscription: {
      readonly autoChargeExcess: boolean;
      readonly cancelledAt: any | null;
      readonly createdAt: any;
      readonly id: string;
      readonly plan: PlanSlug;
      readonly status: SubscriptionStatus;
      readonly valueCents: number;
    } | null;
  };
};
export type SubscriptionPlansQuery = {
  response: SubscriptionPlansQuery$data;
  variables: SubscriptionPlansQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "valueCents",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "SubscriptionPlan",
    "kind": "LinkedField",
    "name": "subscriptionPlans",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "slug",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      (v0/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "comingSoon",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "activePaymentProvider",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Viewer",
    "kind": "LinkedField",
    "name": "viewer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RestaurantSubscription",
        "kind": "LinkedField",
        "name": "subscription",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "plan",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "autoChargeExcess",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cancelledAt",
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "SavedCard",
        "kind": "LinkedField",
        "name": "savedCards",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "creditCardBrand",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "creditCardNumber",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "holderName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isPrimary",
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SubscriptionPlansQuery",
    "selections": (v3/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "SubscriptionPlansQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "bcf22ddb5a661629bb19a489f27f3e69",
    "id": null,
    "metadata": {},
    "name": "SubscriptionPlansQuery",
    "operationKind": "query",
    "text": "query SubscriptionPlansQuery {\n  subscriptionPlans {\n    slug\n    name\n    valueCents\n    comingSoon\n  }\n  activePaymentProvider\n  viewer {\n    subscription {\n      id\n      plan\n      status\n      valueCents\n      autoChargeExcess\n      cancelledAt\n      createdAt\n    }\n    savedCards {\n      id\n      creditCardBrand\n      creditCardNumber\n      holderName\n      isPrimary\n      createdAt\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "15f8c6ce1b5c65c32cb29e569ffe2a01";

export default node;
